import type { TO_UserData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTOUserData: Omit<TO_UserData, 'selectedVariable'> = {
  title: 'Default User Title',
  viewType: 'Avatar'
};
